// extracted by mini-css-extract-plugin
export default {"supplementBox":"c1EPnZ3nfIFJBh0OCQU5"};